import enLocale from 'element-ui/lib/locale/lang/en' //引入element语言包
const en_US = {
  "home":{
    "bgTitle1":"Get all Lenovo content with one account",
    "bgTitle2":"An account. Complete management in one place. Welcome to Account Dashboard",
    "login":"Login",
    "register":"Create your Lenovo ID",
    "help":"Help",
    "legal":"Terms of use",
    "privacy":"Privacy Statement",
    "lenovoVip":"My Lenovo Rewards",
    "lenovoVipText":"Earn rewards for future purchases from everything you buy on Lenovo.com! Earn extra rewards for engaging with us and sharing Lenovo love with friends and family!",
    "accountSecurity":"Account Security",
    "accountSecurityText":"To protect the security of your Lenovo ID, there are many ways to protect your Lenovo ID and privacy, including changing your password in time, binding your secure mobile phone and email, setting password protection and more",
    "singleSign":"Single Sign On",
    "singleSignText":"Lenovo ID gives you access to additional or exclusive features directly from Lenovo and our partners, using one account across all Lenovo sites.",
    "lenovoHelp":"Help",
    "lenovoHelpText":"Get expert answers and advice on Lenovo products and services.",
    "more":"Learn More",
  },
  "help":{
    "Note":"Note: If there is no verification code mail in the mailbox inbox, please check the mail in the trash",
    "accountAppeal":  "Account appeal",
    "incorrectEP": "Email format is incorrect",
    // "incorrectEP": "Email format or phone number format is incorrect",
    "appealAccount":  "Appeal Account:",
    "findAccount": "Retrieving account",
    "submitApplications": 'If your account is stolen or your mobile phone number and email address are no longer used and you cannot receive the verification code, please submit the application for approval.',
    "submitButton": 'Submit an application',
    "backPrevious": 'Back to previous page',
    "back": 'Back',
    "nextStep": 'Next',
    "progressQuery": 'Application progress query',
    "appeal": 'Create Appeal',
    "contactInfor": 'Contact details',
    "accountInfor": 'Account information',
    "completeAppeal":'Completion of appeal',
    "appealPrompt1": '1. Submitting an appeal can retrieve the stolen account, and solve problems such as the inability to properly change the secret and the inability to modify the secret security.',
    "appealPrompt2": '2. Appeal results will usually be sent to the mailbox you left within 3 working days, please pay attention to check.',
    "businessType": 'Business type:',
    "placeholder1": 'Email or phone number',
    "gameUsers": 'Game user',
    "enterGrievanceAccount": 'Please enter the appeal account',
    "enterEmail1": 'Please enter email',
    // "incorrectEmail": 'Incorrect email format or mobile number format',
    "againFill": "Please don't repeat the complaint",
    "contactFill": 'Fill in the contact information of receiving the appeal result',
    "contactDetails": 'Contact details:',
    "ContactEmail": 'Contact email:',
    "appealResult": 'This email is used to receive the appeal result',
    "code": 'Verification code:',
    "basicAccountInfor": 'Basic account information',
    "usedEmail": 'Used email:',
    "usedphone": 'Used phone:',
    "registrationTime": 'Registration time:',
    "name": 'Name:',
    "idNumber": 'Id number:',
    "idPhoto": 'Id photo:',
    "enterUsedEmail": 'Enter the bound email',
    "enterUsedphone": 'Enter the bound phone number',
    "enterRegistrationTime": 'Enter the registration time',
    "chineseName": 'Chinese name',
    "idName": 'Please enter an 18-digit id number',
    "upload": 'Click to upload',
    "uploadPhotos": 'Please upload photos of the front and back of the ID card',
    "imageExceed": '1.The size of each image must not exceed 2MB (2MB=2048KB)',
    "imageExceed2": "2. Must provide at least 3 screenshots of the order, and include the game's first and last payment order before being stolen. If the cumulative recharge is less than 3, all consumer orders must be provided. The screenshot of the consumer order must be able to see the merchant's order. Number and payment time",
    "imageExceed3": '3. Accounts without recharge in the game need to provide a screenshot of the verification code when the account is initially registered or a screenshot of the business hall corresponding to the mobile phone number',
    "onlyUsed": '2.The id picture is only used for verification of identity in case of account appeal. No other use is allowed.',
    "noId": '3.If you do not have an ID card, you can also provide pictures of household registration book, passport, military officer card, soldier card, Hong Kong, Macao and Taiwan pass;',
     "accountUseInfor": 'Account usage information',
     "gameName": 'Game name:',
     "gameName1": 'Game name',
     "gameService": 'Game service:',
     "gameService1": 'Game service',
     "gameNicknames": 'Game nicknames:',
     "gameNicknames1": 'In-game nicknames',
     "gameID": 'Game ID:',
     "gameID1": 'Game ID',
     "Gamename3": 'Game name',
     "rechargeOrder": 'Recharge order:',
     "otherInfor": 'Other information:',
     "service": "Contact details:",
     "cService": "Customer service QQ: 3007422129",
     "oService": "Online service",
     "deliveryAddress": 'Delivery address:',
     "addressUsed": 'Please enter the shipping address you used',
     "consumptionInfor": 'Consumption information:',
     "enterConsumptionInfor": 'Please enter your consumption information',
     "douInfor": 'Le dou information:',
     "enterDouInfor": 'Please enter the number of le beans',
     "orderNo": 'Order number:',
     "enterOrderNo": 'Please enter the order number',
     "addInfor": 'Additional information:',
     "backupData": 'Backup data type:',
     "photoContact": 'Photo or contact information',
     "lastTime": 'Last use time:',
     "enterLastTime": 'Enter the last time used',
     "complaintAccepted": 'Complaint accepted',
     "photosBacked": 'Photos backed up in the cloud service:',
     "Previous": 'Return',
     "receiveEmail": 'Receive the result of the appeal via email',
     "enterEmail": 'Please enter your email',
     "enterCode": 'Code',
     "required": '* is required',
     "workingDay": 'The appeal result will be sent to the contact email you filled in within 3 working days',
     "workingDay7": 'Please do not submit an account appeal repeatedly. If there are multiple people in your account appealing at the same time, we will notify you of the appeal result within 7 working days.',
     "done": 'Done',
     "errEmail": 'Contact email format error',
    "enterName": 'Please enter your name',
    "incorrectEmail1": 'E-mail format is incorrect',
    "incorrectPhone": 'Phone number format is incorrect',
    "enterNumber": 'Please enter the ID number',
    "idNumber18": 'Please enter the 18-digit ID number',
    "enterGameName": 'Please enter the game name',
    "enterInGameName": 'Please enter in-game name',
    "enterZService": 'Please enter zone service',
    "enterGameID": 'Please enter the game ID',
    "onlyJpg": 'Only JPG, PNG and JPEG image formats are supported!',
    "imageSize": 'The uploaded image size cannot exceed 2MB!',
    "twoImage": 'No more than 2 uploaded pictures!',
    "FileImage": 'No more than 5 uploaded pictures!',
    "errorImage": 'Upload image failed!',
    "errorImage1": 'The word limit for the name of the uploaded picture is exceeded!',
    "uploadId": 'Please upload your ID',
    "uploadOrder": 'Please upload your order information',
    "sure": 'Confirm',
    "getCode": 'Get verification code',
    "enterCode": 'please enter verification code',
    "codeError": 'Verification code error',
    "invalidCode": 'Verification code is invalid',
    "securityInfor": 'Reset security information',
    "upperLimit": 'The number of verification codes sent reaches the upper limit',
    "emailNoAgain": "Please don't repeat the complaint",
    "phoneNoAgain": "Please don't repeat the complaint",
  },
  "appeal": {
    "idResult": 'Lenovo ID appeal result',
    "bindInfor": 'Please enter the information you need to bind',
    "SetPassword": 'Please set password',
    "successfulAppeal": 'Successful appeal,authorization and verification',
    "chooseEmailP": 'Please select the security information you need to reset',
    "securityInfor": 'Reset security information',
    "passAccount": 'Congratulations on passing the account appeal review',
    "checkCode": 'The appeal system has sent the authorization code to your contact email, please check your authorization code in your contact email',
    "recivedCode": 'Authorization code received:',
    "enterAuthoriCode": 'Please enter the authorization code',
    "secureEmail": 'Reset secure email',
    "changeInfor": 'After reset, you can use this email to log in and use it as an authentication method to change security information',
    "reset": 'Reset',
    "resetPhone": 'Reset safe phone',
    "changePhone": 'After reset, you can use this phone to log in and use it as an authentication method to change security information',
    "resetPassword": 'Reset your password',
    "completeSet": 'Complete set',
    "enterGraphicCode": 'Enter the graphic verification code',
    "sentToEmail": 'Please enter the characters shown above and click the button below. The verification code will be sent to your email',
    "getVCode": 'Get verification code',
    "resend": 'Resend',
    "enterEmailVerCode": 'Please enter the email verification code',
    "pEnterGraphicCode": 'Please enter the graphic verification code',
    "pEnterGraphicCode1": 'Enter code ',
    "requestAgain": 'Too many requests, please try again later',
    "verificationCodeError": 'Graphic verification code error',
    "verificationCodeError1": 'Verification code error',
    "enterNewPassword": 'Enter a new password',
    "surePassword": 'Confirm password',
    "password8": 'The password must contain at least 8-20 English characters and at least the following three types: uppercase letters, lowercase letters, numbers, and symbols.',
    "emptyCode": 'Password cannot be empty',
    "twoInconsistencies": 'Two inconsistencies',
    "passwordNotRules": 'Password does not meet the rules',
    "requestLocked": 'Request is locked',
    "newExists": 'New user already exists',
    "codeFrozen": 'Account has been frozen',
    "vCodeError": 'Verification code error',
    "cheackOk": 'Please check if the information entered is correct',
    "enterAuthoriCode1": 'You have timed out, revisit the reset link to enter authorization code',
    "accountNotExist": 'Account does not exist',
    "emailSetUp": 'Your secure email has been set up',
    "returnHome": 'It will automatically return to the home page after',
    "accountSet": 'You can make Settings related to account security',
    "enterPhoneCode": 'Please enter mobile phone number',
    "SentToPhone": 'Enter the characters shown above, and then click the button below. The captcha will be sent to phone',
    "SMSCode": 'Please enter SMS verification code',
    "authorizationError": 'Authorization code error',
    "ACodeExpired": 'Authorization code expired',
    "enterNewPassword": 'Enter a new password',
    "SmSError": 'SMS code error',
    "phoneSetUp": 'Your security phone has been set up',
    "linkExpired": 'The link has expired, please refill the appeal form',
    "note1": 'Note: the phone number or email must be valid and not registered with LenovoIDEnter a new password'
  },
  "freezing":{
    "AccountEnable": 'Account enable',
    "confirmInfor": 'Please confirm account information',
    "accountDisabled": 'Account disabled',
    "successActiviva": 'Successfully activated',
    "disableSuccess": 'Disable the success',
    "currentDisabled": 'The current account has been disabled, please confirm whether it is enabled',
    "UID": 'UID (unique identification of Lenovo ID) :',
    "currentName": 'Current account username :',
    "note": 'Note: after this account is disabled, the user will not be able to do anything',
    "no": 'No',
    "yes": 'Yes',
    "linkExpired": 'The link is invalid and cannot be operated',
  },
  "security":{
    "linkSecurity": 'Generate links to reset security information:',
    "linkAccount": 'Generate account disable/enable links:',
    "UserId": 'Please enter UserID',
    "submit": 'Submit',
    "optionNempty": 'The option cannot be empty',
    "resetSecurity": 'Request for security information reset',
    "applyInformation": 'Please enter the following information and apply',
    "applyAccepted": 'Apply accepted',
    "userEmail": "Please view the details in the work order system and send the link to reset the security information to the user's email. ",
    "userIDInvalid": "UserID invalid",
    "notSubmit": 'The Account did not submit appeal',
    "notMatch": 'Email does not match account',
    "access": 'You don‘t have access to this page',
  },
  ...enLocale
}

export default en_US



// WEBPACK FOOTER //
// ./src/i18n/language/en_US.js